import { Header } from "../components/Header";
import styles from "./css/HomePage.module.css";

export const HomePage = () => {
    <title>home</title>

    return (
        
        <div className={styles.pageContainer}>
            <Header />
            <div className={styles.betaBanner}>
                מנתחת יקרה!
    האתר עדיין בהרצה – ייתכנו שינויים ותקלות 🛠️
</div>
            <div
                className={`${styles.mainImageSection} main-content-area`}
            >
                <div className={styles.contentFlexRow}>
                    <div className={styles.centerBox}>
<div className={styles.infoContainer}>
    <h2>ברוכות הבאות!</h2>

    <p>
        המערכת נבנתה כדי לאפשר ניהול חכם ומסודר של עבודתכן עם המטופלים.
        המערכת פועלת כמו יומן חכם שמרכז במקום אחד את כל כלי העבודה היומיומיים:
    </p>

    <ul>
        <li>ניהול ורישום מטופלים בצורה נוחה וברורה</li>
        <li>שמירת טפסים, מסמכים ותצפיות לאורך זמן</li>
        <li>מעקב מסודר אחר תהליך הטיפול</li>
        <li>ניתוח ראשוני לסיטואציות באמצעות AI (בכפוף למגבלת החבילה)</li>
    </ul>

    <p>
        המערכת עדיין בהרצה, ולכן ייתכנו שינויים ושיפורים בהמשך.  
        נשמח מאוד לשמוע מכן על כל תקלה או הצעה — המשוב שלכן עוזר לנו לדייק את המערכת עבורכן.
    </p>
    <p>תודה על שיתוף הפעולה❤️</p>

    {/* <p className={styles.footerNote}>
        כשהתהליך ברור — ההתקדמות מדויקת יותר.  
        הכל במקום אחד, בשיתוף פעולה מלא — בשביל ההצלחה של כל ילד.
    </p> */}
</div>
                    </div>
<div className={styles.loginGuideContainer}>
    <h2>איך מתחברים?</h2>

    <ul>
        <li>לחצי על כפתור "התחברות".</li>
        <li>בחרי כניסה עם חשבון גוגל.</li>
        <li>מלאי את הפרטים הראשוניים — ואת בפנים.</li>
    </ul>
</div>
                </div>
                <div className={styles.infoBoxesContainer}>
                    <div className={`${styles.infoBox} ${styles.purpleBox}`}>
                        <h3>טעויות הן הזדמנות ללמידה – גם לנו</h3>
                        <p>
                            הורים ומטפלות עושים טעויות – וזה בסדר.
                            השאלה היא איך מגיבים לעצמנו.
                            בפוסט הזה אני משתפת איך אפשר להפוך תסכול של הורה לכלי מחזק להמשך.
                        </p>
                    </div>
                    <div className={`${styles.infoBox} ${styles.orangeBox}`}>
                        <h3>החיזוק הלא מדובר</h3>
                        <p>
                            לפעמים מבט, חיוך או טון הקול שלנו – הם אלה שמחזקים התנהגות.
                            בלי לשים לב – אנחנו מחזקים דווקא את מה שאנחנו לא רוצים.
                            הפוסט הזה מסביר איך "לכוון" את החיזוקים הקטנים בצורה חכמה.
                        </p>
                    </div>
                    <div className={`${styles.infoBox} ${styles.yellowBox}`}>
                        <h3>מה עושים כשילד מתעלם שוב ושוב?</h3>
                        <p>
                            התעלמות יכולה להיות סוג של תקשורת.
                            במקום לכעוס – ננסה להבין:
                            מה הוא מנסה להגיד?
                            ממה הוא בורח?
                            הפוסט הזה מציע כלים פשוטים לתגובה נכונה וחכמה.
                        </p>
                    </div>
                    <div className={`${styles.infoBox} ${styles.greenBox}`}>
                        <h3>שיתוף פעולה לא מתחיל בצעקה</h3>
                        <p>
                            רוצים שילד ישתף פעולה?
                            קודם כל נוודא שהוא מקבל יחס מכבד, שהוא מובן, שיש לו בחירה.
                            הפוסט הזה נותן כלים להורים ולמנתחות לעידוד שיתוף פעולה יומיומי.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};
